import { FormDialogButton } from "@constellation-academy/epic-ui";
import { Toast } from "primereact/toast";
import React, { useContext, useRef } from "react";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { createVideoSourceButton_CreateVimeoVideoSourceMutation } from "@relay/createVideoSourceButton_CreateVimeoVideoSourceMutation.graphql";
import { CREATE_VIMEO_VIDEO_SOURCE_MUTATION } from "./create-video-source-button.graphql";
import { VideoSourcesScreenContext } from "../../video-sources.context";
import { VideoSourceForm } from "../video-source-form/video-source-form.component";
import { VideoSourceFormState } from "../video-source-form/video-source-form.types";

export const CreateVideoSourceButton = () => {
	const { t } = useTranslation("common");
	const toast = useRef<Toast>(null);
	const { connectionId } = useContext(VideoSourcesScreenContext);

	const [createVimeoVideoSource, isCreatingVimeoVideoSource] =
		useMutation<createVideoSourceButton_CreateVimeoVideoSourceMutation>(
			CREATE_VIMEO_VIDEO_SOURCE_MUTATION,
		);

	const handleVideoSourceFormOnSubmit = (onHide: () => void, values: VideoSourceFormState) => {
		createVimeoVideoSource({
			variables: {
				input: {
					name: values.name,
					accessToken: values.accessToken!,
				},
				connections: [connectionId],
			},
			onCompleted: () => {
				onHide();
				toast.current?.show({
					severity: "success",
					life: 3000,
					summary: t("videoSources.savedSummary"),
					detail: t("videoSources.createdDetail"),
				});
			},
			onError: () => {
				toast.current?.show({
					severity: "error",
					life: 3000,
					summary: t("videoSources.savedSummary"),
					detail: t("videoSources.notCreatedDetail"),
				});
			},
		});
	};

	return (
		<>
			<Toast ref={toast}></Toast>
			<FormDialogButton<VideoSourceFormState>
				buttonLabel={t("videoSources.createButton")}
				dialogTitle={t("videoSources.createDialogTitle")}
				disabled={isCreatingVimeoVideoSource}
			>
				{({ formikRef, onHide }) => {
					return (
						<VideoSourceForm
							ref={formikRef}
							isCreating
							onSubmit={(values) => {
								handleVideoSourceFormOnSubmit(onHide, values);
							}}
						/>
					);
				}}
			</FormDialogButton>
		</>
	);
};
